import React, { useEffect, useState } from "react";
import axios from "axios";
import cookie from "js-cookie";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import Loader from "../../components/shared/Loader";
import { updateMeta } from "../../store/actions/metaAction";
import { useDispatch } from "react-redux";

const cleanUrl = url =>
	decodeURI(decodeURI(url?.split(".sa")?.pop()?.replaceAll(" ", "") || url));

const SeoRedirectsCreate = () => {
	const [source, setSource] = useState("");
	const [destination, setDestination] = useState("");
	const [redirectCode, setRedirectCode] = useState(301);
	const [loading, setLoading] = useState(false);
	const dispatch = useDispatch();
	const history = useHistory();

	useEffect(() => {
		dispatch(
			updateMeta({
				title: "اضافة رابط اعادة توجيه",
				breadcrumb: "اعادة التوجيه",
				button: {
					show: false,
					text: null,
					link: null,
				},
			})
		);
	}, [dispatch]);

	const handleSourceBlur = () => {
		let val = cleanUrl(source);
		if (val?.[val.length - 1] === "/") val = val.slice(0, -1);
		setSource(val);
	};

	const handleSubmit = e => {
		e.preventDefault();
		if (!source || !destination || !redirectCode) {
			return toast.error("جميع البيانات مطلوبة");
		}
		setLoading(true);
		axios
			.post(
				`${process.env.REACT_APP_API_URL}/seoRedirects`,
				{ source, destination, redirectCode: Number(redirectCode) },
				{
					headers: {
						Authorization: `Bearer ${cookie.get("token")}`,
						Accept: "application/json",
					},
				}
			)
			.then(function () {
				toast.success("تم اضافة رابط اعادة التوجيه بنجاح!");
				history.push("/seoRedirects/index");
			})
			.catch(function () {
				toast.error("خطأ، برجاء المحاولة مره اخرى!");
				setLoading(false);
			});
	};

	return (
		<section>
			{loading && <Loader />}
			<form onSubmit={handleSubmit}>
				<div className="row">
					<div className="col-md-8">
						<div className="card">
							<div className="card-body">
								<div className="form-item">
									<label htmlFor="source">
										المصدر{" "}
										<small style={{ fontSize: "12px" }}>
											* برجاء اضافة العنوان القصير
										</small>
									</label>
									<input
										type="text"
										id="source"
										value={source}
										dir="ltr"
										onChange={e => setSource(e.target.value)}
										onBlur={handleSourceBlur}
									/>
								</div>

								<div className="form-item">
									<label htmlFor="destination">الهدف</label>
									<input
										type="text"
										id="destination"
										value={destination}
										dir="ltr"
										onChange={e => setDestination(e.target.value)}
									/>
								</div>

								<div className="form-item">
									<label htmlFor="redirectCode">كود اعادة التوجيه</label>
									<input
										type="number"
										id="redirectCode"
										value={redirectCode}
										onChange={e => setRedirectCode(e.target.value)}
									/>
								</div>
							</div>
						</div>
						<div className="form-item mt-3">
							<button type="submit" className="bt bt-success btn-block">
								اضافة
							</button>
						</div>
					</div>
				</div>
			</form>
		</section>
	);
};

export default SeoRedirectsCreate;
